module.exports = __webpack_public_path__ + "static/media/SCDream1.47fb61ab.otf";